import { Theme } from '@mui/material';
/**
 * Styling for ccfQuickReplyCard
 * @returns ccfQuickReplyCard CSS properties as a JSON object
 * @example ccfQuickReplyCardStyles(theme)
 */
const ccfCopilotCardStyles = (theme: Theme) => {
  const styles = {
    copilotContainer: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme?.palette?.background?.paper,
      //   height:'100%',
      // },
      // copilotContainerAgentSearch: {
      //   display: 'flex',
      //   flexDirection: 'column',
      //   backgroundColor: theme?.palette?.background?.default,
      height: 'calc(100% - 4rem)',
    },
    cardsContainer: {
      flex: '1',
      overflow: 'auto',
      marginBottom: '0.625rem',
    },
    copilotCard: {
      background: theme?.palette?.background?.paper,
      boxShadow: 'none',
      padding: '0.625rem 0.75rem 0.625rem 0.625rem',
      cursor: 'pointer',
      '*': {
        wordBreak: 'break-word',
      },

      '.ac-container': {
        borderRadius: '6px',
      },

      '.ac-image': {
        borderRadius: '6px',
      },

      '.ac-selectable': {
        borderRadius: '0',
        '&:hover': {
          filter:
            'invert(28%) sepia(93%) saturate(1435%) hue-rotate(176deg) brightness(98%) contrast(101%)',
        },
      },
      '.ac-selectable#greenConfidenceDot':{
        borderRadius: '0',
        '&:hover': {
          filter: 'brightness(0) saturate(100%) invert(72%) sepia(22%) saturate(3865%) hue-rotate(184deg) brightness(92%) contrast(91%)',
        },
      },
      
      '#subTitleIntent': {
        color: '#006398 !important',
      },
      '.ac-actionSet': {
        display: 'flex',
        justifyContent: 'flex-end !important',
      },

      '.ac-pushButton': {
        backgroundColor: '#fff',
        height: '15px',
        color: '#003D7A',
        border: '1px solid #B0CDDB',
        borderRadius: '4px',
        fontSize: '13px',
        fontWeight: '600',
        '&:hover': {
          backgroundColor: 'none !important',
          cursor: 'pointer',
        },
      },

      '.ac-choiceSetInput-compact': {
        backgroundColor: '#fff',
        height: '36px',
        padding: '0 6px',
        border: '1px solid #AFC1CE',
        borderRadius: '4px',
        color: '#333333',
        option: {
          height: '36px',
          backgroundColor: '#fff',
          color: '#333333',
          '&:hover': {
            backgroundColor: theme?.palette?.background?.noteInput,
          },
        },
      },

      '#webLinksContainer': {
        '.ac-textBlock': {
          textDecoration: 'underline',
        },
      },

      '#transferSummary, #autopilotTransferSummary': {
        '.ac-textBlock': {
          paddingLeft: '1.438rem !important',
        },
      },

      '#stepsContainer': {
        backgroundColor: theme?.palette?.text?.white,
        padding: '0.625rem !important',
        border: `0.063rem solid #E5E8EB`,
      },

      '#internalUseContainer': {
        backgroundColor: theme?.palette?.text?.white,
        padding: '0.625rem !important',
        border: `0.063rem solid #E5E8EB`,
      },

      '#webLinksTitle, #imagesTitle, #processStepsTitle, #salesOffersTitle, #complianceTitle, #internalUseTitle':
        {
          '.ac-image': {
            borderRadius: '0',
          },

          '&:hover': {
            filter: 'none',
          },

          '.ac-selectable': {
            '&:hover': {
              filter: 'none',
            },
          },
        },

      '#kbLinks, #kbImages, #kbProcessSteps, #feedbackTopics, #kbInternalUse': {
        boxShadow: '0px 2px 2px 0px #0000001A',
      },

      '#icons': {
        '.ac-image': {
          borderRadius: '0px !important',
        },
      },

      '#emailResponseContainer': {
        marginLeft: '0.625rem !important',
        marginTop: '0.313rem !important',
      },

      '#sparkleIcon': {
        '.ac-image': {
          height: '1.063rem !important',
        },
      },

      '#errorMessageContainer': {
        '.ac-textBlock': {
          marginLeft: '0.375rem',
          color: `${theme?.palette?.background?.callControls} !important`,
        },
      },

      '#responseLengthTextContainer': {
        '.ac-textBlock': {
          marginLeft: '0.375rem',
        },
      },

      '#responseLengthSelectContainer': {
        marginBottom: '0.7rem',
        '.ac-input-container': {
          width: '40%',
        },
      },

      '#emailIcon': {
        '.ac-image': {
          height: '0.9rem !important',
          Width: '0.875rem !important',
        },
      },

      '#generateActionContainer': {
        '.ac-pushButton': {
          height: '1.75rem',
          width: '6rem',
          color: theme?.palette?.text?.white,
          fontWeight: '600',
          backgroundColor: theme?.palette?.background?.copilotAddButton,
          border: `1px solid ${theme?.palette?.background?.copilotAddButton}`,
          borderRadius: '0.25rem',
          marginTop: '0.313rem !important',
          '&:hover': {
            filter: 'none',
          },
        },
        '.ac-actionSet': {
          justifyContent: 'flex-end !important',
        },
      },

      '#addTopicActionContainer': {
        '.ac-pushButton': {
          height: '1.75rem',
          width: '6rem',
          background: theme?.palette?.text?.white,
          fontWeight: '600',
          color: `${theme?.palette?.text?.clearText} !important`,
          border: `1px solid ${theme?.palette?.background?.digitalTag}`,
          borderRadius: '0.25rem',
          marginBottom: '0.5rem',
          '&:hover': {
            filter: 'none',
          },
        },
        '.ac-actionSet': {
          justifyContent: 'flex-start !important',
        },
      },

      '#customTopics0, #customTopics1, #customTopics2': {
        '.ac-input-container': {
          height: '2rem !important',
        },
        '.ac-input.ac-textInput': {
          borderRadius: '0.25rem  !important',
          border: '1px solid',
          borderColor: theme?.palette?.background?.copilotGenerateButton,
          marginLeft: '0.438rem !important',
          paddingLeft: '0.875rem',
          outline: 'none',
        },
      },

      '#requiredCompactId': {
        '.ac-input-container': {
          height: '2.25rem',
          width: '14.813rem !important',
          marginBottom: '0.5rem !important',
          '&:hover': {
            filter: 'none',
          },
        },
        '.ac-input.ac-multichoiceInput.ac-choiceSetInput-compact.ac-input-required':
          {
            borderRadius: '0.25rem !important',
            outline: 'none',
            borderColor: theme?.palette?.background?.copilotGenerateButton,
          },
      },

      '#responseOptionsContainer': {
        '.ac-textBlock': {
          fontSize: '0.813rem !important',
          padding: '0.25rem !important',
        },
        backgroundColor: theme?.palette?.background?.copilotCardBackground,
        paddingLeft: '0.75rem !important',
      },

      '#topicContainer': {
        '.ac-columnSet': {
          marginRight: '2.5rem !important',
        },
        '.ac-container': {
          marginBottom: '0.313rem !important',
        },
      },

      '#clearButton0, #clearButton1, #clearButton2': {
        '.ac-selectable': {
          background: theme?.palette?.background?.copilotCardBackground,
          border: 'unset',
          marginTop: '0.250rem !important',
          paddingRight: '1.25rem !important',
          fontWeight: 'bold',
          color: `${theme?.palette?.text?.black} !important`,
          '&:hover': {
            filter: 'none',
          },
        },
        '.ac-actionSet': {
          height: '1.063rem',
          marginTop: '0.313rem !important',
        },
        '.ac-actionSet .ac-pushButton ': {
          height: '0.75rem ',
          width: '3rem',
        },
      },

      '#CustomizeSelectionContainer': {
        marginTop: '0.438rem !important',
      },
    },
    responseIcons: {
      display: 'flex',
      marginLeft: 'auto',
      marginTop: '0.313rem',
      columnGap: '0.5rem',
    },
    icons: {
      '&:hover svg path': {
        fill: theme?.palette?.text?.noteLabel,
      },
    },
    nullHover: {
      '&:hover': {
        background: 'none',
      },
      padding: '0',
    },
    textField: {
      width: '100%',
      padding: '0.625rem',
      backgroundColor: theme?.palette?.background?.paper,
      position: 'sticky',

      '& .MuiInputBase-root': {
        background: theme?.palette?.background?.noteInput,
        borderRadius: '0.75rem',
        fontWeight: '600',
        position: 'sticky',
        height: '2.5rem',
        color: '#637A87',
        fontSize: '0.75rem',
        margin: '0 0.625rem',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme?.palette?.background?.default,
      },
      // '#searchInput' : {
      //   padding: '0.625rem',
      // },
    },
    searchIcon: {
      transform: 'rotate(90deg)',
      cursor: 'pointer',
    },
    copilotContent: {
      color: theme?.palette?.text?.contrastText,
      border: '0.063rem solid #d8dde0',
      margin: '0.625rem',
      borderRadius: '0.5rem',
      backgroundColor: theme?.palette?.background?.paper,
      width: '97%',
    },
    copilotContentVoice: {
      color: theme?.palette?.text?.contrastText,
      border: '0.063rem solid #d8dde0',
      margin: '0.625rem',
      borderRadius: '0.5rem',
      backgroundColor: theme?.palette?.background?.paper,
      width: '80%',
    },
    responseContainer: {
      bottom: 0,
      backgroundColor: '#fff !important',
    },
    responseDiv: {
      padding: '0.5rem 1.25rem 0.5rem 1.25rem',
      border: '0.031rem solid',
      borderRadius: '0.5rem',
      borderColor: theme?.palette?.text?.lightGrey,
      display: 'flex',
      // justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      columnGap: '0.5rem',
    },
    responseText: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: theme?.palette?.text?.black,
      fontWeight: '600',
    },
    transcriptionText: {
      fontSize: '0.8rem',
      lineHeight: '1rem',
      color: theme?.palette?.text?.black,
      fontWeight: '600',
      margin: '0.5rem 1.7rem',
    },
    line: {
      margin: 0,
      border: `0.063rem solid ${theme?.palette?.border?.light}`,
    },
    nbrSparkle: {
      display: 'flex',
      marginLeft: '0.625rem',
      marginTop: '0.313rem',
      flexDirection: 'column',
      height: '1.25rem',
      width: '1.25rem',
    },
    dancingDotsIcon: {
      fontSize: '50px',
    },
    copilotInteractionAnimation: {
      width: 'inherit',
      height: '40px',
      padding: '0px 20px',

      // .dancingDotsIcon: {
      //   fontSize: "50px",
      // }
    },
    newCarouselStyles: {
      mainCard: {
        display: 'flex',
        alignItems: 'center',
      },
      backgroundColor: theme?.palette?.background?.paper,
      responseText: {
        fontSize: '0.75rem',
        lineHeight: '1rem',
        color: theme?.palette?.text?.main,
        fontWeight: '600',
      },
      indicators: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0.25rem',
        minwidth: '3rem',
      },
      indicator: {
        height: '0.25rem',
        borderRadius: '50%',
        background: theme?.palette?.background?.darkGrey,
        cursor: 'pointer',
        border: 'none',
        display: 'block',
        minWidth: '0.25rem',
        padding: '0rem',
      },
      activeIndicator: {
        height: '0.25rem',
        borderRadius: '50%',
        cursor: 'pointer',
        border: 'none',
        display: 'block',
        minWidth: '0.25rem',
        background: theme?.palette?.text?.noteLabel,
        padding: '0rem',
      },
      card: {
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme?.palette?.background?.paper,
        padding: '0.625rem',
        width: '100%',
        '&:hover div': {
          backgroundColor: theme?.palette?.background?.noteInput,
        },
      },
      cardContent: {
        boxShadow: 'none',
        padding: '0rem',
        borderRadius: '1.5rem',
        '&:hover svg path': {
          fill: theme?.palette?.text?.noteLabel,
        },
        '&:hover div': {
          backgroundColor: theme?.palette?.background?.noteInput,
          borderRadius: '0.5rem',
        },
      },
      carouselDots: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '0.25rem',
        columnGap: '0.188rem',
        alignSelf: 'center',
        margin: '0.25rem',
      },
      iconsHover: {
        '&:hover svg path': {
          fill: theme?.palette?.text?.noteLabel,
        },
      },
    },
    journeySummaryContainer: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#F5F8FA',
      height: '100%',
    },
    journeySummaryContainerVoice: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#F5F8FA',
      height: '100%',
      width: '80%',
    },
  };
  return styles;
};

export default ccfCopilotCardStyles;
